import React, { useEffect, useState } from "react";
import { ThreeDots, TailSpin } from "react-loader-spinner";
import Snackbar from "@mui/material/Snackbar";
import Pagination from "@mui/material/Pagination";
import BaseLayout from "../../layout/BaseLayout";

import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import {
  changerEtatUtilisateurParId,
  getListeUtilisateur,
  modificationUtilisateur,
  rechercherUtilisateurParParam,
} from "../../services/utilisateurs/UtilisateursRequest";
import { MultiSelect } from "react-multi-select-component";
import { getListeNiveauEtude } from "../../services/niveau-etude/NiveauEtudeRequest";
import {
  ajoutEleve,
  ajoutServicePourEleve,
  associeServicePourEleve,
  chargerFichierEleve,
  deleteEleve,
  getExempleFichierChargerListeEleve,
  getListeElevePagination,
  getListeElevePaginationOne,
  getListeServiceAssocie,
  getListeServiceAssocieParEleveParAnnee,
  getListeServiceNonAssocie,
  getListeServiceNonAssocieParEleveParAnnee,
  getListeToutService,
  rechercherMontantRestantParService,
  supprimerFichierEleve,
  supprimeServiceAssocieEleve,
  supprimeServiceEleve,
} from "../../services/eleve/EleveRequest";
import { getListeAnneeAcademique } from "../../services/annee-academique/AnneeAcademiqueRequest";
import { useNavigate } from "react-router-dom";

const languageOption = {
  allItemsAreSelected: "Tous les items sont selectionnées.",
  clearSearch: "Vider la recherche",
  clearSelected: "Vider la selection",
  noOptions: "Pas d'options",
  search: "Rechercher",
  selectAll: "Tout choisir",
  selectAllFiltered: "Select All (Filtered)",
  selectSomeItems: "Selectionner...",
  create: "Créer",
};

const Eleves = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
    pagePagination: 1,
  });
  const [loadingData, setLoadingData] = useState(true);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [desactiveLoading, setDesactiveLoading] = useState(false);
  const [chargeListeLoading, setChargeListeLoading] = useState(false);
  const [eleveInfo, setEleveInfo] = useState(null);
  const [eleveListe, seteleveListe] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [niveauListe, setNiveauListe] = useState([]);
  const [anneeScolaireListe, setAnneeScolaireListe] = useState([]);
  const [serviceListe, setServiceListe] = useState([]);
  const [listeServiceDisponible, setListeServiceDisponible] = useState([]);

  const [listeServiceAssocie, setListeServiceAssocie] = useState([]);

  const [nom, setNom] = useState("");
  const [prenoms, setPrenoms] = useState("");
  const [matricule, setMatricule] = useState("");
  const [niveauSelected, setNiveauSelected] = useState("");
  const [anneeScolaire, setAnneeScolaire] = useState("");
  const [nomParent, setNomParent] = useState("");
  const [prenomsParent, setPrenomsParent] = useState("");
  const [contactParent, setContactParent] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [anneeAssocie, setAnneeAssocie] = useState("");
  const [selectService, setSelectService] = useState("");
  const [montantRestant, setMontantRestant] = useState("");
  const [errorRestant, setErrorRestant] = useState("");

  const [searchTerm, setSearchTerm] = useState("");

  const { vertical, horizontal } = snackbarPosition;

  const TableElement = ({ eleve }) => {
    return (
      <tr key={eleve.id}>
        <td className="px-4">
          {eleve.nom} {eleve.prenoms}
        </td>
        <td className="px-4">{eleve.matricule}</td>
        <td className="px-4">{eleve.niveau ? eleve.niveau.designation : ""}</td>
        {eleve.parent ? (
          <td className="px-4">
            {eleve.parent.nom} {eleve.parent.prenoms}
          </td>
        ) : (
          <td className="px-4"></td>
        )}
        <td className="px-4">{eleve.anneeacademique ? `${eleve.anneeacademique.designation}` : ""}</td>
        <td className="w-40 px-4">
          <div className="flex items-center gap-x-3">
            <label
              htmlFor="delete-warning"
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => {
                document.getElementById("delete-warning").click();
                setEleveInfo(eleve);
              }}
            >
              <DeleteIcon />
            </label>
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => modalVoirDetailEleve(eleve)}
            >
              <VisibilityIcon />
            </button>
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => modalAssocieServiceEleve(eleve)}
            >
              <AddBusinessIcon />
            </button>
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => modalEditEleve(eleve)}
            >
              <EditIcon />
            </button>
          </div>
        </td>
      </tr>
    );
  };

  const modalDesactive = (eleve) => {
    setEleveInfo(eleve);
    document.getElementById("desactive-warning").click();
  };

  const modalUploadListeEleve = () => {
    document.getElementById("charge-liste").click();
  };

  const modalEditEleve = (eleve) => {
    document.getElementById("ajout-eleve").click();
    setEleveInfo(eleve);
    setNom(eleve.nom);
    setPrenoms(eleve.prenoms);
    setMatricule(eleve.matricule);
    setNiveauSelected(eleve.niveau ? eleve.niveau.id : "");
    setAnneeScolaire(eleve.anneeacademique ? eleve.anneeacademique.id : "");
    setNomParent(eleve.parent ? eleve.parent.nom : "");
    setPrenomsParent(eleve.parent ? eleve.parent.prenoms : "");
    setContactParent(eleve.parent ? eleve.parent.contact : "");
  };

  const modalCreateEleve = () => {
    setEleveInfo(null);
    setNom("");
    setPrenoms("");
    setMatricule("");
    setNiveauSelected("");
    setAnneeScolaire("");
    setNomParent("");
    setPrenomsParent("");
    setContactParent("");
  };

  const modalVoirDetailEleve = (eleve) => {
    setEleveInfo(eleve);
    clearForm();
    document.getElementById("eleve-detail").click();
  };

  const clearFormulaireEnregistrementEleve = () => {
    setNom("");
    setPrenoms("");
    setMatricule("");
    setNiveauSelected("");
    setNomParent("");
    setPrenomsParent("");
    setContactParent("");
  };

  // ouvre la modal de service associé à l'élève
  const modalAssocieServiceEleve = (eleve) => {
    document.getElementById("eleve-service").click();
    setAnneeAssocie("");
    setSelectService("");
    setEleveInfo(eleve);
    setListeServiceAssocie([]);
    setListeServiceDisponible([]);
  };

  const getListeDesEleve = () => {
    setLoadingData(true);
    getListeElevePaginationOne(0, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        seteleveListe(res.data.donnee.eleves);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  // Récupère la liste des services non associés à un élève
  const getServiceNonAssocieParEleve = (anneeId, eleveId) => {
    getListeServiceNonAssocieParEleveParAnnee(anneeId, eleveId)
      .then((res) => {
        setLoadingData(false);
        let servicesData = [];

        res.data.donnee.map((item) => {
          servicesData.push({
            label: item.designation,
            value: item.id,
          });
        });
        setListeServiceDisponible(servicesData);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  // Récupère la liste des services associés à un élève
  const getServiceAssocieParEleve = (anneeId, eleveId) => {
    getListeServiceAssocieParEleveParAnnee(anneeId, eleveId)
      .then((res) => {
        setLoadingData(false);
        setListeServiceAssocie(res.data.donnee);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  /**
   *
   * @param {annee} anneeId
   *
   * == Selectionne l'année academique et fait les requêtes
   * == pour voir les services associés et non associés
   *
   */
  const getListeDesServiceParEleve = (anneeId) => {
    setSelectedServices([]);
    setListeServiceAssocie([]);
    setListeServiceDisponible([]);
    setAnneeAssocie(anneeId);
    setSelectService("");

    getServiceNonAssocieParEleve(anneeId, eleveInfo.id);
    getServiceAssocieParEleve(anneeId, eleveInfo.id);
  };

  const getMontantRestantParEleve = (service) => {
    setSelectService(service);

    rechercherMontantRestantParService(anneeAssocie, eleveInfo.id, service)
      .then((res) => {
        setLoadingData(false);
        setMontantRestant(res.data.donnee);
      })
      .catch((err) => {
        setLoadingData(false);
        if (err.response && err.response.data.donnee) {
          setErrorRestant(err.response.data.donnee);
        } else {
          setErrorRestant("");
        }
        console.log("api error", err);
      });
  };

  const clearForm = () => {
    setSelectService("");
    setAnneeAssocie("");
    setMontantRestant("");
  };

  const ajoutNouvelEleve = () => {
    setAddLoading(true);

    const services = [];
    selectedServices.map((item) => {
      services.push(item.value);
    });

    const eleveData = {
      id: eleveInfo ? eleveInfo.id : "",
      matricule: matricule,
      niveauId: niveauSelected,
      anneeId: anneeScolaire,
      nom: nom,
      prenoms: prenoms,
      matricule: matricule,
      servicesId: services,
      parent: {
        contact: contactParent,
        nom: nomParent,
        prenoms: prenomsParent,
      },
    };

    ajoutEleve(eleveData)
      .then((res) => {
        setSuccessMessage("Elève enregistré avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("ajout-eleve").click();
        getListeDesEleve();
        clearFormulaireEnregistrementEleve();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const chargerListeEleve = () => {
    setAddLoading(true);
    const formData = new FormData();
    const services = [];
    selectedServices.map((item) => {
      services.push(item.value);
    });

    formData.append("fichierCsv", selectedFile);
    formData.append("servicesId", services);
    formData.append("anneeId", anneeScolaire);
    formData.append("niveauId", niveauSelected);

    chargerFichierEleve(formData)
      .then((res) => {
        setSuccessMessage("Liste des élèves enregistrée avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("charge-liste").click();
        getListeDesEleve();
        clearFormulaireEnregistrementEleve();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const supprimerLaListeDesEleves = () => {
    setAddLoading(true);
    const formData = new FormData();
    formData.append("fichierCsv", selectedFile);
    formData.append("servicesId", "0");
    formData.append("anneeId", "0");
    formData.append("niveauId", "0");

    supprimerFichierEleve(formData)
      .then((res) => {
        setSuccessMessage("Liste des élèves supprimé avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("charge-liste-delete").click();
        getListeDesEleve();
        clearFormulaireEnregistrementEleve();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const supprimerEleve = () => {
    setDeleteLoading(true);

    console.log("ELEVE", eleveInfo);

    deleteEleve(eleveInfo.id)
      .then((res) => {
        setSuccessMessage("Elève supprimé avec succès");
        getListeDesEleve();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("delete-warning").click();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err.response.data) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  // association de service à un élève
  const associationDeService = () => {
    const services = [];
    selectedServices.map((item) => {
      services.push(item.value);
    });

    const eleveService = {
      anneeId: parseInt(anneeAssocie),
      eleveId: eleveInfo.id,
      servicesId: services,
    };

    associeServicePourEleve(eleveService)
      .then((res) => {
        setSuccessMessage("Services ajoutés avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        setSelectedServices([]);
        getServiceAssocieParEleve(anneeAssocie, eleveInfo.id);
        getServiceNonAssocieParEleve(anneeAssocie, eleveInfo.id);
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const deleteServiceDeEtablissement = (serviceId) => {
    setDeleteLoading(true);

    supprimeServiceAssocieEleve(anneeAssocie, eleveInfo.id, serviceId)
      .then((res) => {
        setSuccessMessage("Service retiré avec succès");
        getServiceAssocieParEleve(anneeAssocie, eleveInfo.id);
        getServiceNonAssocieParEleve(anneeAssocie, eleveInfo.id);
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err.response.data) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const changerEtatEleve = () => {
    setDesactiveLoading(true);

    if (eleveInfo.enabled) {
      changerEtatUtilisateurParId(eleveInfo.id)
        .then((res) => {
          setSuccessMessage("Utilisateur désactivé avec succès");
          getListeDesEleve();
          setSnackbarOpenSuccess(true);
          setDesactiveLoading(false);
          document.getElementById("desactive-warning").click();
        })
        .catch((err) => {
          setDesactiveLoading(false);
          if (err.response.data) {
            setErrorMessage(err.response.data.donnee);
            setSnackbarOpenError(true);
          } else {
            setErrorMessage("Une erreur s'est produite, rééssayer!");
            setSnackbarOpenError(true);
          }
          console.log("api error", err);
        });
    } else {
      changerEtatUtilisateurParId(eleveInfo.id)
        .then((res) => {
          setSuccessMessage("Utilisateur activé avec succès");
          getListeDesEleve();
          setSnackbarOpenSuccess(true);
          setDesactiveLoading(false);
          document.getElementById("desactive-warning").click();
        })
        .catch((err) => {
          setDesactiveLoading(false);
          if (err.response.data) {
            setErrorMessage(err.response.data.donnee);
            setSnackbarOpenError(true);
          } else {
            setErrorMessage("Une erreur s'est produite, rééssayer!");
            setSnackbarOpenError(true);
          }
          console.log("api error", err);
        });
    }
  };

  const telechargeExemple = () => {
    setChargeListeLoading(true);

    getExempleFichierChargerListeEleve()
      .then((res) => {
        setChargeListeLoading(false);
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", 'Exemple_fichier_liste_eleves.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        setChargeListeLoading(false);
        console.log("api error", err);
      });
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const chooseFile = () => {
    document.getElementById("formInput").click();
  };

  const handleFileInput = (e) => {
    const fileUploaded = e.target.files[0];
    setSelectedFile(fileUploaded);
  };

  const searchEleve = () => {
    setSearchLoading(true);

    getListeElevePaginationOne(
      pageQuery.page,
      pageQuery.size,
      searchTerm,
      anneeAssocie,
      niveauSelected
    )
      .then((res) => {
        setSearchLoading(false);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
        seteleveListe(res.data.donnee.eleves);
      })
      .catch((err) => {
        setSearchLoading(false);
        console.log("api error", err);
      });
  };

  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    console.log("PAGINATION", value);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value,
    }));
    if (searchTerm.length !== 0) {
      getListeElevePaginationOne(value - 1, pageQuery.size)
        .then((res) => {
          setLoadingData(false);
          seteleveListe(res.data.donnee.eleves);
          setPageQuery((prev) => ({
            ...prev,
            nombrePage: res.data.donnee.totalPages,
          }));
        })
        .catch((err) => {
          setLoadingData(false);
          console.log("api error", err);
        });
    } else {
      getListeElevePaginationOne(value - 1, pageQuery.size, searchTerm)
        .then((res) => {
          seteleveListe(res.data.donnee.eleves);
          setPageQuery((prev) => ({
            ...prev,
            nombrePage: res.data.donnee.totalPages,
          }));
          setLoadingData(false);
        })
        .catch((err) => {
          setLoadingData(false);
          console.log("api error", err);
        });
    }
  };

  useEffect(() => {
    setLoadingData(true);
    getListeElevePaginationOne(pageQuery.page, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        seteleveListe(res.data.donnee.eleves);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient")
          navigate("/login")
        }
      });

    getListeToutService()
      .then((res) => {
        setLoadingData(false);
        let servicesData = [];

        res.data.donnee.map((item) => {
          servicesData.push({
            label: item.designation,
            value: item.id,
          });
        });
        setListeServiceDisponible(servicesData);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });

    getListeNiveauEtude()
      .then((res) => {
        setLoadingData(false);
        setNiveauListe(res.data.donnee);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });

    getListeAnneeAcademique()
      .then((res) => {
        setLoadingData(false);
        setAnneeScolaireListe(res.data.donnee);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  }, []);

  return (
    <BaseLayout>
      <div className="w-11/12 xl:w-10/12 mx-auto pt-32 pb-20">
        <h1 className="text-2xl text-black font-bold">Elèves</h1>
        <div className="mt-10">
          <div className="mb-5 flex items-end justify-between">
            <div className="flex items-end gap-x-3">
              <div>
                <label className="label">
                  <span className="label-text">Rechercher</span>
                </label>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Rechercher"
                  className="input input-bordered w-40 max-w-xs"
                />
              </div>
              <div className="">
                <label className="label">
                  <span className="label-text">Année academique</span>
                </label>
                <select
                  value={anneeAssocie}
                  onChange={(e) => setAnneeAssocie(e.target.value)}
                  className="w-40 select select-bordered font-normal w-full"
                >
                  <option value="" disabled selected>
                    Choisir une année
                  </option>
                  <option value="">Toutes</option>
                  {anneeScolaireListe.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.debut} - {item.fin}
                    </option>
                  ))}
                </select>
              </div>
              <div className="">
                <label className="label">
                  <span className="label-text">Niveau d'étude</span>
                </label>
                <select
                  value={niveauSelected}
                  onChange={(e) => setNiveauSelected(e.target.value)}
                  className="w-40 select select-bordered font-normal w-full"
                >
                  <option value="" disabled selected>
                    Choisir un niveau
                  </option>
                  <option value="">Tout</option>
                  {niveauListe.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
              </div>
              <button
                className="w-14 h-12 bg-stone-800 text-white rounded-md flex items-center justify-center"
                onClick={searchEleve}
              >
                {!searchLoading ? (
                  <SearchIcon />
                ) : (
                  <TailSpin
                    height="25"
                    width="25"
                    color="#fff"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={searchLoading}
                  />
                )}
              </button>
            </div>
            <div className="flex items-center gap-x-3">
              <label
                htmlFor="ajout-eleve"
                className="bg-momo-blue text-center text-white px-3 py-2 rounded-lg font-medium cursor-pointer"
                onClick={modalCreateEleve}
              >
                Ajouter un élève
              </label>
              {chargeListeLoading ? (
                <button className="bg-momo-blue w-32 px-4 py-2.5 rounded-lg text-white font-bold flex items-center justify-center cursor-default pointer-events-none">
                  <ThreeDots
                    height="20"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </button>
              ) : (
                <div className="dropdown dropdown-bottom dropdown-end">
                  <label
                    tabIndex={0}
                    className="bg-momo-blue w-fit px-4 py-2 rounded-md text-center text-white font-medium flex items-center justify-center cursor-pointer"
                  >
                    Charger la liste
                  </label>
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu p-2 shadow bg-base-100 rounded-md w-40 mt-2"
                  >
                    <button
                      className="h-11 flex items-center hover:bg-gray-100 rounded-md px-3 font-bold"
                      onClick={telechargeExemple}
                    >
                      Exemple
                    </button>

                    <button
                      className="h-11 flex items-center hover:bg-gray-100 rounded-md px-3 font-bold"
                      onClick={modalUploadListeEleve}
                    >
                      Charger
                    </button>

                    <button
                      className="h-11 flex items-center hover:bg-gray-100 rounded-md px-3 font-bold"
                      onClick={() => document.getElementById("charge-liste-delete").click()}
                    >
                      Supprimer
                    </button>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="table table-compact w-full mb-2">
              <thead>
                <tr>
                  <th className="capitalize py-4 px-4">Nom & prénoms</th>
                  <th className="capitalize py-4 px-4">Matricule</th>
                  <th className="capitalize py-4 px-4">Niveau d'étude</th>
                  <th className="capitalize py-4 px-4">Nom & prénoms parent</th>
                  <th className="capitalize py-4 px-4">Année scolaire</th>
                  <th className="capitalize py-4 px-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {!loadingData && eleveListe.length > 0 ? (
                  eleveListe.map((item, index) => (
                    <TableElement key={index} eleve={item} />
                  ))
                ) : !loadingData && eleveListe.length === 0 ? (
                  <tr>
                    <td colSpan="6">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <ErrorOutlineIcon />
                        <p className="font-medium text-red-500">
                          Aucun élément trouvé
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && eleveListe.length === 0 ? (
                  <tr>
                    <td colSpan="6">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex justify-end">
              <Pagination
                count={pageQuery.nombrePage}
                page={pageQuery.pagePagination}
                variant="outlined"
                shape="rounded"
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* MODAL AJOUT ELEVE */}
      <input type="checkbox" id="ajout-eleve" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">
            {eleveInfo === null ? "Ajouter un élève" : "Modifier cet élève"}
          </h3>
          <div className="py-4">
            <div className="flex items-center gap-x-4">
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Nom</span>
                </label>
                <input
                  disabled={addLoading}
                  type="text"
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                  placeholder="Samuel"
                  className="input input-bordered w-full"
                />
              </div>
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Prénoms</span>
                </label>
                <input
                  disabled={addLoading}
                  type="text"
                  value={prenoms}
                  onChange={(e) => setPrenoms(e.target.value)}
                  placeholder="Smith"
                  className="input input-bordered w-full"
                />
              </div>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Matricule</span>
                </label>
                <input
                  disabled={addLoading}
                  type="text"
                  value={matricule}
                  onChange={(e) => setMatricule(e.target.value)}
                  placeholder="05782277M"
                  className="input input-bordered w-full"
                />
              </div>
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Niveau d'étude</span>
                </label>
                <select
                  value={niveauSelected}
                  onChange={(e) => setNiveauSelected(e.target.value)}
                  className="select select-bordered font-normal w-full"
                >
                  <option value="" disabled selected>
                    Choisir un niveau
                  </option>
                  {niveauListe.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="w-full">
              <label className="label">
                <span className="label-text">Année scolaire</span>
              </label>
              <select
                value={anneeScolaire}
                onChange={(e) => setAnneeScolaire(e.target.value)}
                className="select select-bordered font-normal w-full"
              >
                <option value="" disabled selected>
                  Choisir une année
                </option>
                {anneeScolaireListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.debut} - {item.fin}
                  </option>
                ))}
              </select>
            </div>
            {!eleveInfo ? (
              <div>
                <label className="label">
                  <span className="label-text">Service</span>
                </label>
                <MultiSelect
                  options={listeServiceDisponible}
                  value={selectedServices}
                  onChange={setSelectedServices}
                  overrideStrings={languageOption}
                  labelledBy="Choisir un service"
                />
              </div>
            ) : null}
            <p className="font-bold text-lg text-momo-blue pt-5">
              Parent de l'élève
            </p>
            <div className="flex items-center gap-x-4">
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Nom</span>
                </label>
                <input
                  disabled={addLoading}
                  type="text"
                  value={nomParent}
                  onChange={(e) => setNomParent(e.target.value)}
                  placeholder="Samuel"
                  className="input input-bordered w-full"
                />
              </div>
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Prénoms</span>
                </label>
                <input
                  disabled={addLoading}
                  type="text"
                  value={prenomsParent}
                  onChange={(e) => setPrenomsParent(e.target.value)}
                  placeholder="Smith"
                  className="input input-bordered w-full"
                />
              </div>
            </div>
            <div className="w-full">
              <label className="label">
                <span className="label-text">Contact</span>
              </label>
              <input
                disabled={addLoading}
                type="text"
                value={contactParent}
                onChange={(e) => setContactParent(e.target.value)}
                placeholder="+2550596374853"
                className="input input-bordered w-full"
              />
            </div>
          </div>
          <div className="modal-action">
            {!addLoading ? (
              <label
                htmlFor="ajout-eleve"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="ajout-eleve"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            {eleveInfo === null ? (
              <button
                disabled={addLoading}
                className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
                onClick={ajoutNouvelEleve}
              >
                {!addLoading ? (
                  <span>Enregistrer</span>
                ) : (
                  <ThreeDots
                    height="20"
                    width="40"
                    radius="9"
                    color="#000"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={addLoading}
                  />
                )}
              </button>
            ) : (
              <button
                disabled={addLoading}
                className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
                onClick={ajoutNouvelEleve}
              >
                {!addLoading ? (
                  <span>Modifier</span>
                ) : (
                  <ThreeDots
                    height="20"
                    width="40"
                    radius="9"
                    color="#000"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={addLoading}
                  />
                )}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* CHARGER LISTE DES ELEVE */}
      <input type="checkbox" id="charge-liste" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-xl text-black">
            Charger la liste des élèves
          </h3>
          <div className="text-lg text-center py-4">
            <div>
              <label className="label">
                <span className="label-text">Fichier</span>
              </label>
              <div
                className="w-full h-11 rounded-lg bg-white border border-2 border-gray-300 cursor-pointer flex items-center justify-center"
                onClick={chooseFile}
              >
                <span className="text-sm">
                  {selectedFile ? selectedFile.name : "Choisir un fichier"}
                </span>
              </div>
              <input
                name="file-input"
                type="file"
                id="formInput"
                hidden
                onChange={handleFileInput}
              />
            </div>
            <div className="w-full">
              <label className="label">
                <span className="label-text">Service</span>
              </label>
              <MultiSelect
                options={listeServiceDisponible}
                value={selectedServices}
                onChange={setSelectedServices}
                overrideStrings={languageOption}
                labelledBy="Choisir un profil"
              />
            </div>
            <div className="w-full">
              <label className="label">
                <span className="label-text">Année scolaire</span>
              </label>
              <select
                value={anneeScolaire}
                onChange={(e) => setAnneeScolaire(e.target.value)}
                className="select select-bordered font-normal w-full"
              >
                <option value="" disabled selected>
                  Choisir une année
                </option>
                {anneeScolaireListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.debut} - {item.fin}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-full">
              <label className="label">
                <span className="label-text">Niveau d'étude</span>
              </label>
              <select
                value={niveauSelected}
                onChange={(e) => setNiveauSelected(e.target.value)}
                className="select select-bordered font-normal w-full"
              >
                <option value="" disabled selected>
                  Choisir un niveau
                </option>
                {niveauListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-action flex justify-end gap-x-5">
            {!addLoading ? (
              <label
                id="charge-liste-btn"
                htmlFor="charge-liste"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="charge-liste"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={addLoading}
              className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={chargerListeEleve}
            >
              {!addLoading ? (
                <span>Enregistrer</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* CHARGER SUPPRIMER LISTE DES ELEVE */}
      <input type="checkbox" id="charge-liste-delete" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-xl text-black">
            Charger la liste des élèves à supprimer
          </h3>
          <div className="text-lg text-center py-4">
            <div>
              <label className="label">
                <span className="label-text">Fichier</span>
              </label>
              <div
                className="w-full h-11 rounded-lg bg-white border border-2 border-gray-300 cursor-pointer flex items-center justify-center"
                onClick={chooseFile}
              >
                <span className="text-sm">
                  {selectedFile ? selectedFile.name : "Choisir un fichier"}
                </span>
              </div>
              <input
                name="file-input"
                type="file"
                id="formInput"
                hidden
                onChange={handleFileInput}
              />
            </div>
          </div>
          <div className="modal-action flex justify-end gap-x-5">
            {!addLoading ? (
              <label
                id="charge-liste-delete-btn"
                htmlFor="charge-liste-delete"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
                onClick={() => setSelectedFile(null)}
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="charge-liste-delete"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
                onClick={() => setSelectedFile(null)}
              >
                Annuler
              </label>
            )}
            <button
              disabled={addLoading}
              className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={supprimerLaListeDesEleves}
            >
              {!addLoading ? (
                <span>Valider la suppression</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* DETAIL ELEVE */}
      <input type="checkbox" id="eleve-detail" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-xl text-black">Détail paiement</h3>
          <div className="text-lg pt-4 pb-4">
            <div className="w-full">
              <label className="label">
                <span className="label-text">Année academique</span>
              </label>
              <select
                value={anneeAssocie}
                onChange={(e) => getListeDesServiceParEleve(e.target.value)}
                className="select select-bordered font-normal w-full"
              >
                <option value="" disabled selected>
                  Choisir une année
                </option>
                {anneeScolaireListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.debut} - {item.fin}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-full">
              <label className="label">
                <span className="label-text">Service</span>
              </label>
              <select
                value={selectService}
                onChange={(e) => getMontantRestantParEleve(e.target.value)}
                className="select select-bordered font-normal w-full"
              >
                <option value="" disabled selected>
                  Choisir un service
                </option>
                {listeServiceAssocie.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-full">
              <div className="bg-gray-200 h-14 flex items-center justify-center rounded-lg mt-5">
                <p className="font-bold text-lg text-momo-blue uppercase">
                  Reste à payer :{" "}
                  <span className="text-red-500 capitalize decoration-none">
                    {montantRestant ? montantRestant : 0} FCFA
                  </span>
                </p>
              </div>
              {errorRestant ? (
                <p className="text-sm text-center text-red-600 font-bold mt-3">
                  {errorRestant}
                </p>
              ) : null}
            </div>
          </div>
          <div className="modal-action flex justify-end gap-x-5">
            <label
              id="eleve-detail-btn"
              htmlFor="eleve-detail"
              className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              onChange={clearForm}
            >
              Fermer
            </label>
          </div>
        </div>
      </div>

      {/* DETAIL ASSOCIER SERVICE */}
      <input type="checkbox" id="eleve-service" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box max-w-3xl">
          <h3 className="font-bold text-xl text-black">
            Services associés à l'élève
          </h3>
          <div className="text-lg flex justify-between gap-x-5 pt-8 pb-4">
            <div className="w-1/2">
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Année academique</span>
                </label>
                <select
                  value={anneeAssocie}
                  onChange={(e) => getListeDesServiceParEleve(e.target.value)}
                  className="select select-bordered font-normal w-full"
                >
                  <option value="" disabled selected>
                    Choisir une année
                  </option>
                  {anneeScolaireListe.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.debut} - {item.fin}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Service</span>
                </label>
                <MultiSelect
                  options={listeServiceDisponible}
                  value={selectedServices}
                  onChange={setSelectedServices}
                  overrideStrings={languageOption}
                  labelledBy="Choisir un profil"
                />
              </div>
              <button
                className="w-full h-11 font-bold mt-3 bg-momo-jaune flex items-center justify-center rounded-md"
                onClick={associationDeService}
              >
                Ajouter
              </button>
            </div>
            <div className="w-1/2">
              <div className="w-full">
                <p className="text-green-700 text-center -ml-3">
                  Les services associés
                </p>
                <div className="h-48 overflow-y-scroll pb-4">
                  {listeServiceAssocie.length === 0 ? (
                    <div className="h-full flex items-center justify-center px-2">
                      <p className="w-full py-2 bg-red-100 text-center text-red-600 font-bold rounded-md">
                        Aucun service associé
                      </p>
                    </div>
                  ) : (
                    <div>
                      {listeServiceAssocie.map((item) => (
                        <div
                          className="w-full h-12 rounded-md bg-gray-100 font-bold px-4 flex items-center justify-between mt-3"
                          key={item.id}
                        >
                          <span>{item.designation}</span>
                          <button
                            className="bg-red-600 p-1 rounded-md text-white cursor-pointer flex items-center justify-center"
                            onClick={() =>
                              deleteServiceDeEtablissement(item.id)
                            }
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-action flex justify-end gap-x-5">
            <label
              id="eleve-service-btn"
              htmlFor="eleve-service"
              className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
            >
              Fermer
            </label>
          </div>
        </div>
      </div>

      {/* SUPPRIMER ELEVE */}
      <input type="checkbox" id="delete-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-2xl text-center text-red-500">
            Attention !
          </h3>
          <p className="text-lg text-center py-4">
            Cette action est irréversible
          </p>
          <div className="modal-action flex justify-center gap-x-5">
            {!deleteLoading ? (
              <label
                id="delete-warning-btn"
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={deleteLoading}
              className="bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={supprimerEleve}
            >
              {!deleteLoading ? (
                <span>Supprimer</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={deleteLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* DESACTIVER ELEVE */}
      <input type="checkbox" id="desactive-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3
            className={
              eleveInfo && eleveInfo.enabled
                ? "font-bold text-2xl text-center text-red-500"
                : "font-bold text-2xl text-center text-green-500"
            }
          >
            {eleveInfo && eleveInfo.enabled
              ? "Désactiver cet élève"
              : "Activer cet élève"}
          </h3>
          <div className="modal-action flex justify-center gap-x-5">
            {!desactiveLoading ? (
              <label
                id="desactive-warning-btn"
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={desactiveLoading}
              className={
                eleveInfo && eleveInfo.enabled
                  ? "bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
                  : "bg-green-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              }
              onClick={changerEtatEleve}
            >
              {!desactiveLoading ? (
                <>
                  {eleveInfo && eleveInfo.enabled ? (
                    <span>Désactiver</span>
                  ) : (
                    <span>Activer</span>
                  )}
                </>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={desactiveLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </BaseLayout>
  );
};

export default Eleves;
